import React, { useState, useEffect, useContext } from "react";
import "./Mid-section-Pc.scss"; // CSS file for custom styles

//import context
import { MyContext } from "../../../../tenantsDashContext.jsx";

//components
import TransactionsTable from "./Payments-Table";
import InformationCardPc from "./Information-Card-Pc";
// import PaymentModal from "../../PaymentModal";

//imports for user data
import { useSelector, useDispatch } from "react-redux";

//functions for datat fetching
import {
  fetchTenants,
  getProfile,
} from "../../../../redux/slices/sliceActions";
import MyCalendar from "./ReactCalender";
import TenantsList from "../../Tenants/Mobile-and-Tablet/TenantsList";

const MiddleSectionPc = () => {
  const {
    curerntYear,
    currentMonth,
    monthNames,
    selectedDate,
    setRolesAssigned,
  } = useContext(MyContext);

  //before the component mounts
  const [isLoading, setIsLoading] = useState(true);
  //data fetched from the store
  const dispatch = useDispatch();
  const { user, profile, tenants } = useSelector(
    (state) => state.landlordslice
  );
  const token = user?.accessToken;
  const id = user?.user?.user_id;
  const property_id = user?.user?.propertyId;

  const [profileUpdated, setProfileUpdated] = useState(false);
  const [latestInvoice, setLatestInvoice] = useState([]);
  const [tenantList, setTenantList] = useState([]);

  const [apartmentName, setApartmentName] = useState("");

  //data in the cards
  const [dataInCards, setDataInCards] = useState({});

  useEffect(() => {
    setRolesAssigned(user?.user?.caretaker_roles);

    if (
      selectedDate.month === currentMonth &&
      selectedDate.year === curerntYear
    ) {
      dispatch(getProfile({ id, token, caretaker: true })).then((res) => {
        setProfileUpdated(true);
        console.log("profile update", res);
        setIsLoading(false);
      });
      dispatch(fetchTenants({ property_id, token }));
    } else {
      const year = selectedDate.year;
      const month = selectedDate.month;

      const monthNumber = monthNames.indexOf(month) + 1;

      dispatch(
        getProfile({
          id,
          token,
          caretaker: true,
          time: {
            year: year,
            month: monthNumber,
          },
        })
      ).then((res) => {
        setProfileUpdated(true);
        console.log("profile with time update", res);
        setIsLoading(false);
      });
    }
  }, [selectedDate]);

  useEffect(() => {
    if (profile?.occupiedHouses) {
      setApartmentName(profile.property_name);
      setDataInCards({
        paymentsMade: profile.paidInvoices?.total || 0,
        pendingInvoices: profile.unpaidInvoices?.total || 0,
        numberOfPaymentsMade: profile.totalPaidInvoices || 0,
        numberOfPendingInvoices: profile.totalUnpaidInvoices || 0,
        housesOccupied: profile.occupiedHouses || 0,
        totalHouses: profile.totalHouses || 0,
        arrearsReconciled: profile.totalArrearsPaid || 0,
        totalInvoiceAmount: profile.unpaidInvoices[0]?.amount || 0,
        totalPaymentsAmount: profile.paidInvoices[0]?.amount || 0,
      });

      console.log("my checkups ", dataInCards);
    }
  }, [profile]);

  useEffect(() => {
    // dispatch(getProfile({ id, token, caretaker: true })).then((res) => {
    //   setProfileUpdated(true);
    //   console.log("profilic update", res);
    //   setIsLoading(false);
    // });

    if (
      selectedDate.month === currentMonth &&
      selectedDate.year === curerntYear
    ) {
      dispatch(getProfile({ id, token, caretaker: true })).then((res) => {
        setProfileUpdated(true);
        console.log("profile update", res);
        setIsLoading(false);
      });
    } else {
      const year = selectedDate.year;
      const month = selectedDate.month;

      const monthNumber = monthNames.indexOf(month) + 1;

      dispatch(
        getProfile({
          id,
          token,
          caretaker: true,
          time: {
            year: year,
            month: monthNumber,
          },
        })
      ).then((res) => {
        setProfileUpdated(true);
        console.log("profile with time update", res);
        setIsLoading(false);
      });
    }
  }, [selectedDate]);

  useEffect(() => {
    setTenantList(tenants);
  }, [tenants]);

  const defaultValues = {
    rent: latestInvoice?.rent || "0",
    water: latestInvoice?.water || "0",
    arrears: latestInvoice?.arrears || "0",
    serviceCharge: latestInvoice?.serviceCharge || "0",
    unpaidDeposit: latestInvoice?.unpaidDeposit || "0",
    garbage: latestInvoice?.garbage || "0",
    paymentMethod: latestInvoice?.paymentMethod || "M-Pesa",
    phoneNumber: latestInvoice?.phoneNumber || "",
    referenceNumber: latestInvoice?.referenceNumber || "",
    paymentNarration: latestInvoice?.paymentNarration || "",
  };

  const [seeMoreClicked, setSeeMoreClicked] = useState(false);
  const [seeMoreQuickLinksClicked, setSeeMoreQuickLinksClicked] =
    useState(false);

  // const cardData1 = {
  //   Title: "Invoices Pending",
  //   rent: latestInvoice?.rent || "0",
  //   water: latestInvoice?.water || "0",
  //   arrears: latestInvoice?.arrears || "0",
  //   // serviceCharge: latestInvoice.serviceCharge || "0",
  //   // unpaidDeposit: latestInvoice.unpaidDeposit || "0",
  //   garbage: latestInvoice?.garbage || "0",
  //   totalAmount:
  //     (latestInvoice?.rent || 0) +
  //     (latestInvoice?.water || 0) +
  //     (latestInvoice?.arrears || 0) +
  //     // (latestInvoice.serviceCharge || 0) +
  //     // (latestInvoice.unpaidDeposit || 0) +
  //     (latestInvoice?.garbage || 0),
  // };

  // const cardData2 = {
  //   Title: "Invoices Paid",
  //   rent: paymentProgress?.rent || "0",
  //   water: paymentProgress?.water || "0",
  //   arrears: paymentProgress?.arrears || "0",
  //   serviceCharge: paymentProgress?.serviceCharge || "0",
  //   unpaidDeposit: paymentProgress?.unpaidDeposit || "0",
  //   garbage: paymentProgress?.garbage || "0",
  //   totalAmount:
  //     (paymentProgress?.rent || 0) +
  //     (paymentProgress?.water || 0) +
  //     (paymentProgress?.arrears || 0) +
  //     // (paymentProgress.serviceCharge || 0) +
  //     // (paymentProgress.unpaidDeposit || 0) +
  //     (paymentProgress?.garbage || 0),
  // };
  // const cardData3 = {
  //   Title: "Arrears",
  //   rent: cardData1.rent,
  //   water: cardData1.water,
  //   arrears: cardData1.arrears,
  //   serviceCharge: cardData1.serviceCharge,
  //   unpaidDeposit: cardData1.unpaidDeposit,
  //   garbage: cardData1.garbage,
  //   totalAmount:
  //     (cardData1.rent || 0) +
  //     (cardData1.water || 0) +
  //     (cardData1.arrears || 0) +
  //     (cardData1.serviceCharge || 0) +
  //     (cardData1.unpaidDeposit || 0) +
  //     (cardData1.garbage || 0),
  // };

  //modal

  const [isOpen, setIsOpen] = useState(false);
  const [fieldsToShow, setFieldsToShow] = useState([]);
  const closeModal = () => {
    setIsOpen(false);
    setFieldsToShow([]);
  };
  const openModal = (fieldsToShow) => {
    setFieldsToShow(fieldsToShow);
    console.log(fieldsToShow);
    setIsOpen(true);
  };

  return (
    <>
      {!isLoading ? (
        <div className="mid-section-pc-caretaker">
          <div className="title-container">
            <div className="greeting">Hello {user?.user?.user_name}</div>
            <div className="title">
              Reports for{" "}
              <span style={{ color: "#B39359" }}> {apartmentName}</span>{" "}
            </div>
            {/* <button className="more" onClick={() => {
           setSeeMoreClicked(!seeMoreClicked);
         }}>
           {seeMoreClicked ? "Hide" : "See more"}
         </button> */}
          </div>
          <div className="cards-container">
            <InformationCardPc
              percentage={
                //percentage to 1dp
                (
                  (dataInCards?.housesOccupied / dataInCards?.totalHouses) *
                  100
                ).toFixed(1) || 0
              }
              Title={"Houses Occupied"}
            />
            <InformationCardPc
              Title={"Payments Made"}
              percentage={
                isNaN(
                  (
                    (dataInCards?.paymentsMade /
                      (dataInCards?.paymentsMade +
                        dataInCards?.pendingInvoices)) *
                    100
                  ).toFixed(1)
                )
                  ? 0
                  : (
                      (dataInCards?.paymentsMade /
                        (dataInCards?.paymentsMade +
                          dataInCards?.pendingInvoices)) *
                      100
                    ).toFixed(1)
              }
            />
            <InformationCardPc
              Title={"Pending Invoices"}
              percentage={
                isNaN(
                  (
                    (dataInCards?.pendingInvoices /
                      (dataInCards?.paymentsMade +
                        dataInCards?.pendingInvoices)) *
                    100
                  ).toFixed(1)
                )
                  ? 0
                  : (
                      (dataInCards?.paymentsMade /
                        (dataInCards?.paymentsMade +
                          dataInCards?.pendingInvoices)) *
                      100
                    ).toFixed(1)
              }
            />
          </div>

          <div className="calender-and-recent-enlistings-container">
            <MyCalendar />
            <div className="recent-enlisting-container">
              <div className="title">Recent Enlistings</div>
              <div className="tenant-list-container">
                {tenantList.slice(0, 5).map((tenant, index) => (
                  <div key={index} className="individual-tenant">
                    <div className="shape-and-details">
                      <div className="shape"></div>
                      <div className="name-and-date">
                        <div className="name">{tenant?.tenant_name}</div>
                        <div className="date">
                          {new Date(tenant.created_at).toLocaleString(
                            "default",
                            {
                              month: "short",
                              year: "numeric",
                            }
                          )}
                        </div>
                      </div>
                    </div>
                    <div className="room-number">
                      {tenant?.house.house_number}
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </div>
          <div className="transactions-container">
            <div className="title-container" style={{ marginBottom: "0px" }}>
              <div className="title">Latest Transactions</div>
            </div>
            <TransactionsTable />
          </div>

          {/* <PaymentModal
         isOpen={isOpen}
         closeModal={closeModal}
         defaultValues={defaultValues} // Set default values here
         fieldsToShow={fieldsToShow} // Specify which fields to show
       /> */}
        </div>
      ) : (
        <div className="loading-container">
          <div className="loader"></div>
        </div>
      )}
    </>
  );
};

export default MiddleSectionPc;
